export const visit = (vm, at) => {
vm(require("foundations-components/lang/th.lyaml"));
at({ "th": { "placeholder": "\u0E15\u0E31\u0E27\u0E22\u0E36\u0E14\u0E15\u0E33\u0E41\u0E2B\u0E19\u0E48\u0E07" } });
};